import type { IconComponent } from "@overmap-ai/blocks"
import {
	ArrowDown,
	ArrowLeft,
	ArrowRight,
	ArrowUp,
	Baseline,
	Battery,
	BatteryCharging,
	Bold,
	Box,
	Building2,
	CalendarClock,
	Camera,
	ChartColumnBig,
	ChartLine,
	ChartNoAxesColumnIncreasing,
	Check,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronsLeft,
	ChevronsRight,
	ChevronUp,
	Circle,
	CircleAlert,
	CircleSlash2,
	CircleUser,
	ClipboardCheck,
	CloudRain,
	CloudSnow,
	Columns2,
	Command,
	Copy,
	Cpu,
	CreditCard,
	Crosshair,
	Diamond,
	Download,
	Droplet,
	Ellipsis,
	Eraser,
	ExternalLink,
	Eye,
	EyeOff,
	File,
	FilePen,
	FileText,
	Flag,
	Folder,
	GitBranch,
	Globe,
	GripVertical,
	Heading1,
	Heading2,
	Heading3,
	Highlighter,
	History,
	Import,
	Info,
	Italic,
	Layers,
	Link,
	ListChecks,
	ListFilter,
	ListOrdered,
	ListTodo,
	Lock,
	LogOut,
	Map,
	MapPin,
	MapPinned,
	Maximize2,
	Menu,
	MessageSquareIcon,
	Minus,
	Moon,
	Move,
	Navigation,
	PanelLeft,
	PanelRight,
	Paperclip,
	Pencil,
	Plus,
	Redo,
	RotateCcw,
	Ruler,
	Scan,
	ScanBarcode,
	Search,
	SearchX,
	Settings,
	Shapes,
	SlidersVertical,
	Sparkle,
	SquareDashed,
	SquareUserRound,
	Strikethrough,
	Sun,
	Table,
	TableOfContents,
	TextQuote,
	Thermometer,
	ThumbsDown,
	ThumbsUp,
	Trash,
	TriangleAlert,
	Type,
	Umbrella,
	Underline,
	Undo,
	Unlink,
	Upload,
	User,
	UserPlus,
	Users,
	UserSearch,
	VectorSquare,
	Wind,
	X,
} from "lucide-react"

import type { IconType } from "../components/Icons/typings"

export const modelIconMapping = {
	organization: Building2,
	project: Shapes,
	map: Map,
	step: ClipboardCheck,
	priority: ChartNoAxesColumnIncreasing,
	status: Circle,
	issue: MapPin,
	assetType: Box,
	user: User,
	license: CreditCard,
	navigate: Navigation,
	location: MapPinned,
	attachment: Paperclip,
	copy: Copy,
	dueDate: CalendarClock,
	edit: Pencil,
	delete: Trash,
	download: Download,
	import: Import,
	form: FileText,
	document: FilePen,
	report: FileText,
	upload: Upload,
	search: Search,
	stage: Circle,
	leftPanel: PanelLeft,
	rightPanel: PanelRight,
	filter: ListFilter,
	more: Ellipsis,
	add: Plus,
	close: X,
	check: Check,
	exit: LogOut,
	undo: Undo,
	redo: Redo,
	draggable: GripVertical,
	layout: Columns2,
	graph: ChartLine,
	control: SlidersVertical,
	arrowRight: ArrowRight,
	arrowLeft: ArrowLeft,
	arrowUp: ArrowUp,
	arrowDown: ArrowDown,
	chevronRight: ChevronRight,
	chevronsRight: ChevronsRight,
	chevronLeft: ChevronLeft,
	chevronsLeft: ChevronsLeft,
	chevronDown: ChevronDown,
	chevronUp: ChevronUp,
	minus: Minus,
	indeterminate: Minus,
	settings: Settings,
	expand: Maximize2,
	troubleshoot: SearchX,
	node: Diamond,
	table: Table,
	overlay: Layers,
	camera: Camera,
	pdf: FileText,
	preferences: SlidersVertical,
	link: Link,
	unlink: Unlink,
	info: Info,
	team: SquareUserRound,
	creator: UserPlus,
	text: Type,
	visible: Eye,
	hidden: EyeOff,
	assignee: CircleUser,
	unassigned: CircleUser,
	overview: TableOfContents,
	history: History,
	procedureType: ListChecks,
	refresh: RotateCcw,
	batteryCharge: BatteryCharging,
	globe: Globe,
	thermometer: Thermometer,
	wind: Wind,
	water: Droplet,
	battery: Battery,
	snow: CloudSnow,
	thunderstorm: CloudRain,
	sun: Sun,
	moon: Moon,
	umbrella: Umbrella,
	alertCircle: CircleAlert,
	alertTriangle: TriangleAlert,
	crosshair: Crosshair,
	lock: Lock,
	cpu: Cpu,
	question: Info,
	barchart: ChartColumnBig,
	ai: Sparkle,
	menu: Menu,
	group: Users,
	file: File,
	folder: Folder,
	externalLink: ExternalLink,
	move: Move,
	eraser: Eraser,
	highlight: Highlighter,
	underline: Underline,
	bold: Bold,
	italic: Italic,
	strikethrough: Strikethrough,
	fontColor: Baseline,
	blockquote: TextQuote,
	list: Menu,
	checklist: ListTodo,
	orderedList: ListOrdered,
	separator: Minus,
	heading1: Heading1,
	heading2: Heading2,
	heading3: Heading3,
	thumbsUp: ThumbsUp,
	thumbsDown: ThumbsDown,
	select: SquareDashed,
	ruler: Ruler,
	flow: GitBranch,
	identifier: ScanBarcode,
	scan: Scan,
	geometry: VectorSquare,
	command: Command,
	comment: MessageSquareIcon,
	procedureInitiave: Flag,
	none: CircleSlash2,
	reviewer: UserSearch,
} as const satisfies Record<string, IconComponent>

export const modelIconNameMapping = {
	procedureType: "list-checks",
	assetType: "box",
	issueType: "map-pin",
	document: "file-pen",
	team: "users",
} as const satisfies Record<string, IconType>
